import type { PropsWithChildren } from 'react';

import { cn } from '~/lib/cn';
import type { VariantProps } from '~/lib/variants';
import { variants } from '~/lib/variants';

export type PropertyListValueProps = PropsWithChildren &
  VariantProps<typeof listValue>;

const listValue = variants({
  base: 'max-w-full overflow-hidden text-ellipsis text-end',
  variants: {
    wrap: {
      true: 'text-wrap break-all',
      false: 'text-nowrap',
    },
  },
});

export function PropertyListValue({
  children,
  wrap = false,
}: PropertyListValueProps) {
  return <dd className={cn(listValue({ wrap }))}>{children}</dd>;
}
PropertyListValue.displayName = 'PropertyListValue';
